export default __webpack_public_path__ + "static/media/GlobeIcon.b9ad41d4.svg";